import axios from "axios";

const WEATHER_API_KEY = process.env.REACT_APP_OPENWEATHER_API_KEY;

export async function getCityByCoordinates(latitude, longitude) {	  
    const url = `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&appid=${WEATHER_API_KEY}&units=metric`;
  
    try {
      const response = await axios.get(url);
      console.log(response);
      const city = response.data.name;
      return city;
    } catch (error) {
      console.error('Ошибка при получении города:', error);
      return null;
    }
}

export async function getWeatherByCoordinates(latitude, longitude) {	  
  const url = `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&appid=${WEATHER_API_KEY}&units=metric`;

  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении города:', error);
    return null;
  }
}

export async function getIpAddr() {
  const url = 'https://api64.ipify.org?format=json';
  try {
    const response = await axios.get(url);
    return response.data.ip;
  } catch (error) {
    console.log('Error getting ip address: ', error);
    return null;
  }
}

export async function getGeoposition(ip) {
  const url = `https://ipinfo.io/${ip}/json`;
  try {
    const response = await axios.get(url);
    const [latitude, longitude] = response.data.loc.split(",");
    return {latitude, longitude};
  } catch (error) {
    console.log('Error get geoposition: ', error);
    return null;
  }
}